// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"2dca9245","396":"70e9c09d","685":"504bad76"}[chunkId] + ".chunk.css";
};